import { useLocation } from "react-router";
import { getLanguageFromPath, SupportedLanguage } from "../utils/language";

export const useLanguageFromPath = (): SupportedLanguage => {
  const { pathname } = useLocation();
  return getLanguageFromPath(pathname);
};
